import { render, staticRenderFns } from "./CreateBoardsGroupAndGroup.vue?vue&type=template&id=e8f34920&scoped=true&"
import script from "./CreateBoardsGroupAndGroup.vue?vue&type=script&lang=ts&"
export * from "./CreateBoardsGroupAndGroup.vue?vue&type=script&lang=ts&"
import style0 from "./CreateBoardsGroupAndGroup.vue?vue&type=style&index=0&id=e8f34920&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8f34920",
  null
  
)

export default component.exports